
define("json!uikit/version.json", function () {
return {
  "version": "1.4.1.1"
}
;
});

